import styled from 'styled-components'

export const FieldLabelStyled = styled.label.attrs((props) => ({}))`
    color: ${(props) => props.theme.table.headerColor} !important;
    font-size: ${(props) => props.theme.table.headerFontSize};
    opacity: 1 !important;
`
